import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import {
  Avatar,
  Box,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Radio,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getInitials } from "../../../common/helpers/getInitials";
import HrTaskContentRows from "./HrTaskContentRows";
import { resolveLogicalLinkRoute } from "./hrTaskLinks";
import { HrTask } from "./types";

type Props = {
  task: HrTask;
  isLast: boolean;
  selected: boolean;
  handleSelectHrTask: (taskId: string) => void;
};

const HrTaskListItem = ({
  task,
  isLast,
  selected,
  handleSelectHrTask,
}: Props) => {
  const title = task.presentation.title;
  const defaultAction = task.actions.defaultAction;
  const to = defaultAction
    ? resolveLogicalLinkRoute(defaultAction.link.target)
    : undefined;

  return (
    <Box display="flex" alignItems="center" gap="4px">
      {task.canManuallyAcknowledge && (
        <Radio
          checked={selected}
          onChange={() => handleSelectHrTask(task.id)}
          sx={{ width: "24px", height: "24px", color: "#000A4466" }}
        />
      )}
      <Box
        data-testid="hr-task-card"
        display="flex"
        alignItems="center"
        flex={1}
        sx={{
          position: "relative",
          minWidth: 0,
          bgcolor: "#fff",
          marginBottom: isLast ? "0px" : "16px",
          borderRadius: "8px",
          padding:
            task.presentation.density === "compact" ? "6px 16px" : "16px",
        }}
      >
        <ListItemAvatar>
          <Avatar sx={{ width: "34px", height: "34px" }}>
            {getInitials(title)}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          sx={{ minWidth: 0, overflowWrap: "anywhere" }}
          primary={
            to ? (
              <Box
                component={Link}
                to={to}
                target={defaultAction?.link.openInNewTab ? "_blank" : undefined}
                rel={
                  defaultAction?.link.openInNewTab
                    ? "noopener noreferrer"
                    : undefined
                }
                sx={{
                  color: "inherit",
                  textDecoration: "none",
                  // Stretch card navigation without nesting independent row links.
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    borderRadius: "8px",
                  },
                  "&:focus-visible::after": {
                    outline: "2px solid",
                    outlineColor: "primary.main",
                  },
                }}
              >
                {title}
              </Box>
            ) : (
              title
            )
          }
          secondary={
            <HrTaskContentRows rows={task.presentation.rows} variant="body2" />
          }
          secondaryTypographyProps={{ component: "div" }}
        />
        {to && (
          <ListItemIcon sx={{ justifyContent: "flex-end" }}>
            <Box p={1} mr={-1.5} display="flex">
              <ArrowRightIcon
                sx={{ color: (theme) => theme.palette.primary.light }}
              />
            </Box>
          </ListItemIcon>
        )}
      </Box>
    </Box>
  );
};

export default HrTaskListItem;
